module.exports = __webpack_public_path__ + "media/images/swifticons/newyearseve-0a08168bca7e8c7df398f90f2f1c471d.svg";